import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function ISeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-496">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-497">
        <div data-id="element-498">
          <h2 className="text-3xl font-bold mb-1" data-id="element-499">Bodor i Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-500">
            Compact design sheet fiber laser metal cutting machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-501">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-502">
          <div className="md:col-span-5 flex flex-col items-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-503">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/2023/Fiber%20Laser%20Bodor%20iSeries.png800x800.png" alt="Bodor i Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl mb-4" data-id="element-504" />
            <span className="bg-[#f5693d] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-505">
              Smart, Ultra-Precise
            </span>
          </div>
          <div className="md:col-span-7" data-id="element-506">
            <ul className="space-y-4 text-gray-700" data-id="element-507">
              <li data-id="element-508">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-509">
                  A Compact Design with Complete Protection
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-510">
                  Small occupied space balances complete protection and higher
                  safety.
                </span>
              </li>
              <li data-id="element-511">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-512">
                  Active Anti-collision Function
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-513">
                  Effectively reduce the damage rate of laser heads, help you
                  save maintenance cost.
                </span>
              </li>
              <li data-id="element-514">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-515">
                  Cast Iron Bed
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-516">
                  Featuring good shock absorption, Cast Iron Bed keeps its shape
                  all the way with the optimal mechanical property.
                </span>
              </li>
              <li data-id="element-517">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-518">
                  High Speed Cutting Database
                </strong>
              </li>
              <li data-id="element-519">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-520">
                  No Quiver when Cutting Thin Sheet
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-521">
                  i Series are capable of cutting edges of thin sheet and ensure
                  no quivering marks.
                </span>
              </li>
              <li data-id="element-522">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-523">
                  Bodor Pro 2.0
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-524">
                  CAD and CAM are embedded perfectly in Bodor Pro 2.0 to help
                  you edit graphics. No more extra editing software required.
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-525">
              <a href="https://www.peakedm.com/m7/Bodor%20I%20Series--i-series-high-precision-laser-cutting-machine.html" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-[#f5693d] transition-colors" data-id="element-526">
                <span className="mr-2" data-id="element-527">+</span> Discover More
              </a>
              <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Bodor%20i%20series%20precision%20laser%20cutting%20machine.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md hover:bg-[#002d4d] hover:text-white transition-colors" data-id="element-528">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-529" /> Download Brochure
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-530">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-531">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-532">
              <tr data-id="element-533">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/3" data-id="element-534">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200 w-1/3" data-id="element-535">
                  i5
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center w-1/3" data-id="element-536">
                  i7
                </th>
              </tr>
            </thead>
            <tbody data-id="element-537">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-538">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-539">
                  Operating Area
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-540">
                  1000*1500mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-541">3048*1524mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-542">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-543">
                  Machine overall dimensions
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-544">
                  3630×2200×1940mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-545">4960×2280×2200mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-546">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-547">
                  Laser Output Power
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-548">
                  3000w/2000w/1500w
                </td>
                <td className="px-6 py-4 text-center" data-id="element-549">3000w/2000w/1500w</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-550">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-551">
                  X/Y-axis positioning accuracy
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-552">
                  ±0.05mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-553">±0.05mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-554">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-555">
                  X/Y-axis repositioning accuracy
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-556">
                  ±0.03mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-557">±0.03mm</td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-558">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-559">
                  X/Y-axis Max. linkage speed
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-560">
                  60m/min
                </td>
                <td className="px-6 py-4 text-center" data-id="element-561">100m/min</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}